import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { isEmpty } from 'lodash';

import selectOnlineOrderingLocationBySlug from 'bento-ordering/base/selectors/selectOnlineOrderingLocationBySlug';

function useOnlineOrderingLocationInformation() {
  const { slug: locationSlug } = useParams();
  const locationBySlug = useSelector(
    selectOnlineOrderingLocationBySlug(locationSlug)
  );
  const { location = {} } = locationBySlug;

  if (isEmpty(location)) {
    return null;
  }

  const {
    name: locationName,
    street,
    city,
    state,
    postal_code: postalCode,
    phone_number: phoneNumber
  } = location;

  return {
    locationName,
    street,
    city,
    state,
    postalCode,
    phoneNumber
  };
}

export default useOnlineOrderingLocationInformation;
